import { forwardRef, LiHTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const DropdownListItem = forwardRef<
  HTMLLIElement,
  LiHTMLAttributes<HTMLLIElement>
>(({ className, ...props }, ref) => (
  <li
    className={cn('text-sm [&:hover_.info]:block', className)}
    ref={ref}
    {...props}
  />
))
